import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

/** Campo de texto para segredos, oculto por padrão com botão para mostrar. */
const PasswordField = (props) => {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      size="small"
      fullWidth
      autoComplete="new-password"
      {...props}
      type={visible ? "text" : "password"}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                edge="end"
                aria-label={visible ? "Ocultar valor" : "Mostrar valor"}
                onClick={() => setVisible((v) => !v)}
              >
                {visible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default PasswordField;
